import {
  ERPSeedless,
  ERPRJL,
  ERPUnity,
  ERPOdoo
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";
import { Icons } from "src/library/components/Icon/types";
import { canViewByRoleCodes } from "src/core/shared/utils/canViewByRoleCodes";

import { AdminMain } from "..";
import AdminOrdersPage from "./AdminOrdersPage";
import ExportOrdersPage from "./ExportOrdersPage";
import ImportOrdersPage from "./ImportOrdersPage";
import OrderImportPage from "./OrderImportPage";

const AdminOrders: IRoute[] = [
  {
    exact: true,
    path: "/admin/orders",
    pageComponent: AdminOrdersPage,
    title: "%ORDERS%",
    icon: Icons.CART,
    menuType: "ADMIN_ORDERS",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ],
    permissions: [ "view-order" ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/orders/export",
    pageComponent: ExportOrdersPage,
    title: "Export",
    icon: Icons.DOWNLOAD,
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    menuType: "ADMIN_ORDERS",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ],
    modules: [ "order-export" ],
    permissions: [ "view-order" ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/orders/imports",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: ImportOrdersPage,
    title: "Imports",
    icon: Icons.DOWNLOAD,
    menuType: "ADMIN_ORDERS",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    modules: [ "order-import" ],
    permissions: [ "view-order" ],
    roles: [ "admin" ]
  }
];

const NestedRoutes: IRoute[] = [
  {
    exact: true,
    path: "/admin/orders/imports/:importId",
    pageComponent: OrderImportPage,
    title: "Order Import",
    hidden: true,
    menuType: "ADMIN_ORDERS",
    privateRoute: true,
    parent: AdminOrders[ 3 ],
    modules: [ "order-import" ],
    permissions: [ "create-order" ],
    roles: [ "admin" ]
  }

  // {
  //   exact: true,
  //   path: "/admin/orders/picking-imports/:importId",
  //   pageComponent: OrderPickImportPage,
  //   title: "Order pick import",
  //   hidden: true,
  //   menuType: "EMPTY",
  //   privateRoute: true,
  //   parent: AdminOrders[ 4 ],
  //   erp: [ ERPSeedless ],
  //   modules: [ "order-import" ],
  //   permissions: [ "create-order" ],
  //   roles: [ "admin" ]
  // }
];

export default [ ...AdminOrders, ...NestedRoutes ];
